import { Slot, Stack, useGlobalSearchParams, useRouter } from "expo-router";
import { useCallback } from "react";
import { ScrollView, StyleSheet } from "react-native";

import { isWeb } from "@stepapp/core";
import { Button, palette, spacing } from "@stepapp/ui";
import { useTranslation } from "react-i18next";
import { AppStorage } from "../../src/services/AppStorage";

export type RegisterFormValues = {
  code: string;
  email: string;
  firstName: string;
  lastName: string;
  otpCodeVerified: boolean;
  phoneNumber: string;
};

export default function WelcomeLayout() {
  const { t } = useTranslation();
  const { step } = useGlobalSearchParams();
  const { replace, navigate } = useRouter();

  const welcomeStep = Number(step) || 0;

  const goToNextPage = useCallback(() => {
    const nextStep = welcomeStep + 1;

    if (nextStep === 3) {
      AppStorage().set("afterWalkthrough", true);
      replace("/");
    } else {
      navigate(`/welcome/${nextStep}`);
    }
  }, [navigate, replace, welcomeStep]);

  return (
    <ScrollView contentContainerStyle={styles.contentContainer}>
      {isWeb ? (
        <Slot />
      ) : (
        <Stack
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: palette.common.grayBackground },
          }}
        />
      )}

      <Button
        style={styles.footerButton}
        label={Number(step) === 2 ? t("screens.welcome.letsStart") : t("common.continue")}
        onPress={goToNextPage}
        testID="welcome-continue-button"
        type="primary"
      />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  contentContainer: {
    flex: 1,
  },
  footerButton: {
    flex: isWeb ? 1 : 0,
    backgroundColor: palette.common.grayBackground,
    paddingBottom: spacing.unit * 2.5,
    paddingHorizontal: spacing.unit * 2.5,
    zIndex: 5,
  },
});
